import { render, staticRenderFns } from "./DatatableLoader.vue?vue&type=template&id=5f1fd060&"
import script from "./DatatableLoader.vue?vue&type=script&lang=js&"
export * from "./DatatableLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports